if (!Sparkle.Recaptcha) {
  Sparkle.Recaptcha = {
    siteKey: window.SparkleConfig.recaptcha.siteKey,
    startSession: function () {
      var deferred = new jQuery.Deferred();

      if (!this.siteKey) {
        // Recaptcha is not enabled for this client
        deferred.resolve();
      } else if (this.sessionPromise) {
        // Someone else has already started a session, so use that one instead
        // Nothing to do but return the sessionPromise as usual
      } else {
        // Start a new recaptcha session
        this.sessionPromise = deferred.promise();

        Sparkle.Codeload.import("https://www.google.com/recaptcha/api.js?render=explicit").then(function () {
          grecaptcha.ready(function () {
            var badgeContainer = jQuery('<div data-size="invisible" style="display: none;">').appendTo("body");
            Sparkle.Recaptcha.sessionId = grecaptcha.render(badgeContainer[0], { sitekey: Sparkle.Recaptcha.siteKey });
            deferred.resolve();
          });
        });
      }

      return this.sessionPromise;
    },

    endSession: function () {
      if (this.isSessionStarted()) {
        var deferred = new jQuery.Deferred();

        this.sessionPromise.then(function () {
          grecaptcha.execute(Sparkle.Recaptcha.sessionId, { action: "submit" }).then(function (token) {
            deferred.resolve(token);
          });
          delete Sparkle.Recaptcha.sessionPromise;
          delete Sparkle.Recaptcha.sessionId;
        });

        return deferred.promise(); // Promise passes the recaptcha validation token as the only argument
      } else {
        return new jQuery.Deferred().resolve().promise();
      }
    },

    isSessionStarted: function () {
      return this.sessionPromise !== undefined;
    },

    load: function () {
      return Sparkle.Codeload.import("https://www.google.com/recaptcha/api.js?render=explicit");
    },
  };
}
